import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { fetchApprovalList } from '../actions/approvalActions'

const useFetchingApprovalList = (id) => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(fetchApprovalList())
  }, [dispatch])
}

export default useFetchingApprovalList
